import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0438eb5b")

_pushScopeId("data-v-0438eb5b")
const _hoisted_1 = { class: "apartment-meta__content" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "floating-right-label" }
const _hoisted_4 = {
  key: 0,
  class: "text-gray mr-3"
}
const _hoisted_5 = { class: "flex-grow-1" }
const _hoisted_6 = { class: "apartment-meta__head" }
const _hoisted_7 = { class: "apartment-meta__icon bt-icon bt-icon--sm" }
const _hoisted_8 = { class: "my-1 nowrap" }
const _hoisted_9 = { class: "mr-3" }
const _hoisted_10 = { class: "list-bubbles mt-2" }
const _hoisted_11 = { class: "bt-icon bt-icon--sm text-primary" }
const _hoisted_12 = { class: "bt-icon bt-icon--sm text-primary" }
const _hoisted_13 = { class: "bt-icon bt-icon--sm text-primary" }
const _hoisted_14 = { class: "bt-icon bt-icon--s text-primary" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, {
    class: "apartment-meta card--slim position-relative",
    onClick: _ctx.goToDevices
  }, {
    content: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (_ctx.lastScanDate)
              ? (_openBlock(), _createBlock("small", _hoisted_4, _toDisplayString(_ctx.$t("plantDetail.lastScan", {
                                    date: _ctx.lastScanDate,
                                    time: _ctx.lastScanTime,
                                })), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, [
                _createVNode(_component_InlineSvgScoped, {
                  src: 
                                        require(`@/assets/images/icons/icon-network.svg`)
                                    ,
                  "aria-label": "icon-network"
                }, null, 8, ["src"])
              ]),
              _createVNode("h5", null, _toDisplayString(_ctx.devicesNo) + " " + _toDisplayString(_ctx.$t("AppResource.Devices")), 1)
            ]),
            _createVNode("p", _hoisted_8, [
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.devicesNoAssigned) + " " + _toDisplayString(_ctx.$t("general.assigned")), 1),
              _createVNode("span", null, _toDisplayString(_ctx.devicesNoNotAssigned) + " " + _toDisplayString(_ctx.$t("general.notAssigned")), 1)
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_Button, { class: "p-button-rounded p-button-sm" }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.automationDevicesNo), 1)
              ]),
              _: 1
            }),
            _createVNode("span", _hoisted_11, [
              _createVNode(_component_InlineSvgScoped, {
                src: 
                                    require(`@/assets/images/icons/icon-automation-2.svg`)
                                ,
                "aria-label": "icon-automation-2"
              }, null, 8, ["src"])
            ]),
            _createVNode(_component_Button, { class: "p-button-rounded p-button-sm ml-3" }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.thermoDevicesNo), 1)
              ]),
              _: 1
            }),
            _createVNode("span", _hoisted_12, [
              _createVNode(_component_InlineSvgScoped, {
                src: 
                                    require(`@/assets/images/icons/icon-thermo.svg`)
                                ,
                "aria-label": "icon-thermo"
              }, null, 8, ["src"])
            ]),
            _createVNode(_component_Button, { class: "p-button-rounded p-button-sm ml-3" }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.energyDevicesNo), 1)
              ]),
              _: 1
            }),
            _createVNode("span", _hoisted_13, [
              _createVNode(_component_InlineSvgScoped, {
                src: 
                                    require(`@/assets/images/icons/icon-energy.svg`)
                                ,
                "aria-label": "icon-energy"
              }, null, 8, ["src"])
            ]),
            _createVNode(_component_Button, { class: "p-button-rounded p-button-sm ml-3" }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.securityDevicesNo), 1)
              ]),
              _: 1
            }),
            _createVNode("span", _hoisted_14, [
              _createVNode(_component_InlineSvgScoped, {
                src: 
                                    require(`@/assets/images/icons/icon-security.svg`)
                                ,
                "aria-label": "icon-security"
              }, null, 8, ["src"])
            ])
          ])
        ]),
        _createVNode(_component_Button, {
          icon: "pi pi-chevron-right",
          class: "p-button-text p-button-secondary ml-2 ml-auto",
          onClick: _ctx.goToDevices
        }, null, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onClick"]))
})